module.exports = __webpack_public_path__ + "img/2023-01-09a_2.89a4a101.jpg";